import React, { useEffect, useState } from 'react';

const ExpertLanguages = ({ expert, possibleLanguages }) => {
  const [partnerLanguages, setPartnerLanguages] = useState([]);

  useEffect(() => {
    const langs = expert.languages.values
      .map(
        lang => possibleLanguages.find(item => item.key === lang)?.displayName,
      )
      .filter(x => x);
    setPartnerLanguages(langs);
  }, [expert, possibleLanguages]);

  return (
    <div>{partnerLanguages.length ? partnerLanguages.join(', ') : ''}</div>
  );
};

export default ExpertLanguages;
